import { Component } from '@angular/core';
import { OnInit, ViewChild,ElementRef } from '@angular/core';
import { Table } from 'primeng/table';
import BaseDeCobrosDetalle from 'src/app/shared/models/BaseDeCobrosDetalle';
import { basedecobros } from 'src/app/shared/services/basdecobros.service'; 
import  {IResultadoGeneral}  from 'src/app/shared/models/ResultadoGeneral';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import User from 'src/app/shared/models/user';
import { HttpService } from 'src/app/shared/services/http.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import IExportarBaseDetalle from 'src/app/shared/models/ExportarBaseDetalle';
import { Estatus } from 'src/app/shared/models/Estatus';
import { usuariosComercialService } from 'src/app/shared/services/usuariosComercial.service';
@Component({
  selector: 'app-usuarios-comercial',
  templateUrl: './usuarios-comercial.component.html',
  styleUrls: ['./usuarios-comercial.component.scss']
})
export class UsuariosComercialComponent {
  @ViewChild('filtroInput') filtroInput!: ElementRef;
  @ViewChild('dt1') dt!: Table;
  UsuariosComercial: any[] = [];
  tablaExportar: IExportarBaseDetalle[] = [];
  usuario:User={};
  fecha_dia:any;
  data_editar:any;
  numero_operacion:number=0;
  dspEditarUsuario:boolean=false;
  color_gris_deshabilitadas:string = '#D9D9D9';
  dspAgregarUsuario:boolean=false;
  dspbasedecobros:boolean=false;
  texto_operacion: string = '';
  resultado: IResultadoGeneral = {
    clv_estatus: 0,
    messageDetails: ''
  };
  

    objEstatus:Estatus[]=[{
      clv_activo:0,
      des_estatus:'Desactivado'
    },
    {
      clv_activo:1,
      des_estatus:'Activo'
    }]
    UsuarioComercialForm:FormGroup=new FormGroup({
      nombre:new FormControl('',[Validators.required]),
      apellido_paterno:new FormControl('',[Validators.required]),
      correo:new FormControl('',[]),
      lada: new FormControl('', []),
      celular: new FormControl('', [])
    })

  
  data_editar_basedecobros: BaseDeCobrosDetalle={
    opcion:0,
    cod_usuario:'',
    idx:0,
    id_concepto:0,
    des_concepto:'',
    importe:0,
    id_config_unidad:0,
    des_config_unidad:'',
    id_categoria:0,
    des_categoria:'',
    clv_activo:0,
  };

  constructor(private http:HttpService, private message:MessageService, private auth:AuthService,private usuarioComercialService:usuariosComercialService,
    private confirmationService: ConfirmationService){
    this.cargarInformacionUsuario();
  }

  cargarInformacionUsuario(){
    this.usuario = this.auth.user;
  }
  ObtenerUsuariosComercial(){
    this.usuarioComercialService.getListadoUsuariosComercial().subscribe({
      next: (data) => {
          this.UsuariosComercial = data; 
          setTimeout(() => {
          }, 250);
      },
      error: (err) => {
          console.error('Error al cargar los datos de usuarios', err);
          setTimeout(() => {
          }, 250);
      }
  });
}
    
  

  ngOnInit(): void {
    this.inicializarFechas();
    this.ObtenerUsuariosComercial();
  }

  inicializarFechas(){
    var getYear = new Date().toLocaleDateString('es-MX',{ year: 'numeric'});   
    var getMonth = new Date().toLocaleDateString('es-MX',{ month: '2-digit'});
    var getDay = new Date().toLocaleDateString('es-MX',{day: '2-digit'});
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.fecha_dia=dateFormat;
  }


  mostrarModalEditar(data: any) {
    this.data_editar = data;
    this.dspEditarUsuario = true;
  
    this.UsuarioComercialForm.patchValue({
      nombre: data.nombre,
      apellido_paterno: data.apellido_paterno,
      correo: data.correo,
      lada: data.lada,
      celular: data.celular,
    });
  }
  get f() {
    return this.UsuarioComercialForm.controls;
  }

  confirmarDesactivar(data: any) {
    let estatus_original= data.clv_estatus;
    let texto_desactivar: string = data.clv_estatus == 1 ? 'DESACTIVAR' : 'ACTIVAR';
    let texto_desactivar_header: string = data.clv_estatus == 1 ? 'Desactivar' : 'Activar';
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b>' + texto_desactivar + '</b> el usuario <b>'+data.nombre+' </b>',
      header: 'Confirmacion de ' + texto_desactivar_header,
      icon: 'pi pi-info-circle',
      accept: () => {
        data.cod_usuario=this.usuario.cod;
        data.clv_estatus = data.clv_estatus == 1 ? 0 : 1;
        this.guardarInformacionDesactivar(data);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            data.clv_activo=estatus_original;
            this.message.add({ key: 'msj', severity: 'error', summary: 'Rechazado', detail: 'Se ha Rechazado' });
            break;
          case ConfirmEventType.CANCEL:
            data.clv_activo=estatus_original;
            this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Se ha Cancelado' });
            break;
        }
      }
    });
  }
  abrirModalAgregar(){
    this.UsuarioComercialForm.reset();
    this.dspAgregarUsuario = true;
  }
 
  guardarInformacionDesactivar(data: any) {
    this.usuarioComercialService.editUsuarioComercial(data).subscribe((resp)=> {
      var resultado=resp;
      if(resultado.clv_estatus==1){
        setTimeout(() => {
          this.message.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
          this.UsuarioComercialForm.reset();
          this.cancelarVentanaModal();
        }, 800);
      }
    },
    (error)=> {
      this.message.add({ severity: 'error', summary: 'Error en <Editar Base de Cobros>', detail: 'Contacte al Administrador del Sitio' });
    });
  }

  EditarInformacion() {
    // Validación del formulario
    if (this.UsuarioComercialForm.invalid) {
      this.message.add({ key: 'msj', severity: 'error', summary: 'Formulario Inválido', detail: 'Por favor complete todos los campos correctamente.' });
      return;
    }
    
      // Extraer los valores antes de la confirmación
      const data_enviar = {
        id_usuario:this.data_editar.id_usuario,
        nombre: this.UsuarioComercialForm.get('nombre')?.value,
        apellido_paterno: this.UsuarioComercialForm.get('apellido_paterno')?.value,
        nom_usuario: this.usuario.name,
        cod_usuario: this.usuario.cod,
        correo: this.UsuarioComercialForm.get('correo')?.value,
        lada: this.UsuarioComercialForm.get('lada')?.value, 
        celular: this.UsuarioComercialForm.get('celular')?.value,
        clv_estatus:this.data_editar.clv_estatus,  
        clv_estatus_gerente:this.data_editar.clv_estatus_gerente, 
      };
    
      // Mostrar la confirmación antes de guardar
      this.confirmationService.confirm({
        message: `¿Está seguro que desea guardar el Nuevo Usuario?`,
        header: 'Confirmación de Guardado',
        icon: 'pi pi-info-circle',
        accept: () => {
          // Si el usuario acepta, proceder con el guardado
          this.inicializarFechas(); 
          
          this.usuarioComercialService.editUsuarioComercial(data_enviar).subscribe((resp) => {
            const resultado = resp;
            if (resultado.clv_estatus === 1) {
              setTimeout(() => {
                this.ObtenerUsuariosComercial(); // Volver a cargar la lista de base de cobros
                this.message.add({ severity: 'success', summary: 'Operación Exitosa', detail: 'La información se almacenó correctamente' });
                this.UsuarioComercialForm.reset();
                this.cancelarVentanaModal();
              }, 800);
            }
          }, (error) => {
            this.message.add({ severity: 'error', summary: 'Error en <Guardar Base de Cobros>', detail: 'Contacte al Administrador del Sitio' });
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.message.add({ key: 'msj', severity: 'error', summary: 'Rechazado', detail: 'El guardado fue rechazado.' });
              break;
            case ConfirmEventType.CANCEL:
              this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'El guardado fue cancelado.' });
              break;
          }
        }
      });
    }

  guardarInformacion() {
  // Validación del formulario
  if (this.UsuarioComercialForm.invalid) {
    this.message.add({ key: 'msj', severity: 'error', summary: 'Formulario Inválido', detail: 'Por favor complete todos los campos correctamente.' });
    return;
  }
  
    // Extraer los valores antes de la confirmación
    const data_enviar = {
      nombre: this.UsuarioComercialForm.get('nombre')?.value,
      apellido_paterno: this.UsuarioComercialForm.get('apellido_paterno')?.value,
      nom_usuario: this.usuario.name,
      cod_usuario: this.usuario.cod,
      correo: this.UsuarioComercialForm.get('correo')?.value,
      lada: this.UsuarioComercialForm.get('lada')?.value, 
      celular: this.UsuarioComercialForm.get('celular')?.value,
      clv_estatus:1,  
      clv_estatus_gerente:1, 
    };
  
    // Mostrar la confirmación antes de guardar
    this.confirmationService.confirm({
      message: `¿Está seguro que desea guardar el Nuevo Usuario?`,
      header: 'Confirmación de Guardado',
      icon: 'pi pi-info-circle',
      accept: () => {
        // Si el usuario acepta, proceder con el guardado
        this.inicializarFechas(); 
        
        this.usuarioComercialService.PostUsuarioComercial(data_enviar).subscribe((resp) => {
          const resultado = resp;
          if (resultado.clv_estatus === 1) {
            setTimeout(() => {
              this.ObtenerUsuariosComercial();// Volver a cargar la lista de base de cobros
              this.message.add({ severity: 'success', summary: 'Operación Exitosa', detail: 'La información se almacenó correctamente' });
              this.UsuarioComercialForm.reset();
              this.cancelarVentanaModal();
            }, 800);
          }
        }, (error) => {
          this.message.add({ severity: 'error', summary: 'Error en <Guardar Base de Cobros>', detail: 'Contacte al Administrador del Sitio' });
        });
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.message.add({ key: 'msj', severity: 'error', summary: 'Rechazado', detail: 'El guardado fue rechazado.' });
            break;
          case ConfirmEventType.CANCEL:
            this.message.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'El guardado fue cancelado.' });
            break;
        }
      }
    });
  }


  cancelarVentanaModal() {
    this.texto_operacion = '';
    //this.num_operacion=0;
    this.dspEditarUsuario = false;
    this.dspAgregarUsuario = false;
    this.UsuarioComercialForm.reset();
    this.resultado = {
      clv_estatus: 0,
      messageDetails: ''
    };
  }
    applyFilterGlobal($event: any, stringVal: any) {
      this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
    }
    limpiarFiltro() {
      this.filtroInput.nativeElement.value = ''; // Establecer el valor del filtro en una cadena vacía
      // Puedes llamar a la función applyFilterGlobal aquí si es necesario
    }
    clear(table: Table) {
      table.clear();
      this.limpiarFiltro();
  }
}
